import type { StateCreator } from '@shared-types/zustand.types';

export type CalendarServiceState = {
  selectedTeams: string[];
  setSelectedTeams: (teams: string[]) => void;
  resetSelectedTeams: () => void;
};

export const teamsSlice: StateCreator<CalendarServiceState> = (set) => ({
  selectedTeams: [] as string[],
  setSelectedTeams: (teams: string[]) => set(() => ({ selectedTeams: teams }), false, 'setSelectedTeams'),
  resetSelectedTeams: () => set(() => ({ selectedTeams: [] }), false, 'resetSelectedTeams'),
});
